export default __webpack_public_path__ + "static/media/enquiry.93095882.svg";